/*
 *
 * PracticePage reducer
 *
 */

import { fromJS } from "immutable";
import { storePractice } from "utils/practiceStorage";
import {
  DEFAULT_ACTION,
  GET_PRACTICES_ACTION,
  GET_PRACTICES_SUCCESS_ACTION,
  GET_PRACTICES_FAILED_ACTION,
  SELECT_PRACTICE_ACTION,
} from "./constants";

export const initialState = fromJS({
  practice: null,
  practices: [],
});

function clinicPageReducer(state = initialState, action) {
  switch (action.type) {
    case DEFAULT_ACTION:
      return state;
    case GET_PRACTICES_ACTION:
      return state;
    case GET_PRACTICES_FAILED_ACTION:
      return state;
    case SELECT_PRACTICE_ACTION:
      storePractice(action.practice);

      return state.set("practice", fromJS(action.practice));
    case GET_PRACTICES_SUCCESS_ACTION:
      return state.set("practices", fromJS(action.practices));
    default:
      return state;
  }
}

export default clinicPageReducer;
